import { render, staticRenderFns } from "./Bag.vue?vue&type=template&id=7e46a60a&"
import script from "./Bag.vue?vue&type=script&lang=js&"
export * from "./Bag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../opt/homebrew/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports